export const cookieKeys = {
  subscriptions: 'sb',
};

export const subscriptionCookieSplitter = '~';

export const getSubscriptionCookieCode = (subscriptionCode: string) =>
  `${subscriptionCookieSplitter}${subscriptionCode}${subscriptionCookieSplitter}`;
